import Text from './text';

interface IErrorText {
  label: string;
}

const ErrorText = ({
  label,
}: IErrorText) => {
  return (
    <Text size={'xs'} mt={6} c={'red'}>{label}</Text>
  )
}

export default ErrorText;